import { render, staticRenderFns } from "./ContentDetails.vue?vue&type=template&id=0a488425"
import script from "./ContentDetails.vue?vue&type=script&lang=js"
export * from "./ContentDetails.vue?vue&type=script&lang=js"
import style0 from "./ContentDetails.vue?vue&type=style&index=0&id=0a488425&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports